const imageToBlob = function (imgEl) {
    return new Promise((resolve, reject) => {
        const canvas = document.createElement('canvas');
        canvas.width = imgEl.naturalWidth;
        canvas.height = imgEl.naturalHeight;
        canvas.getContext('2d').drawImage(imgEl, 0, 0);
        canvas.toBlob(blob => {
            if (blob) resolve(blob);
            else reject(new Error('Image conversion failed'));
        }, 'image/png');
    });
}

// 🔁 Convert <canvas> to Blob
const canvasToBlob = function (canvas) {
    return new Promise((resolve, reject) => {
        canvas.toBlob(blob => {
            if (blob) resolve(blob);
            else reject(new Error('Canvas conversion failed'));
        }, 'image/png');
    });
}

const objectToFormData = async function (obj, formdata = new FormData(), parentKey = '') {
    for (const key in obj) {
        if (!obj.hasOwnProperty(key)) continue;

        const value = obj[key];
        const fullKey = parentKey ? `${parentKey}[${key}]` : key;

        if (value instanceof File || value instanceof Blob) {
            formdata.append(fullKey, value);
        }
        else if (value instanceof FileList) {
            Array.from(value).forEach(file => formdata.append(`${fullKey}[]`, file));
        }
        else if (value instanceof HTMLImageElement) {
            const blob = await imageToBlob(value);
            formdata.append(fullKey, blob, 'image.png');
        }
        else if (value instanceof HTMLCanvasElement) {
            const blob = await canvasToBlob(value);
            formdata.append(fullKey, blob, 'canvas.png');
        }
        else if (Array.isArray(value)) {
            for (let i = 0; i < value.length; i++) {
                await objectToFormData({ [i]: value[i] }, formdata, `${fullKey}[]`);
            }
        }
        else if (typeof value === 'object' && value !== null) {
            await objectToFormData(value, formdata, fullKey);
        }
        else {
            formdata.append(fullKey, value);
        }
    }

    return formdata;
}

Object.defineProperties(FormData, {
   parse: {
       value: async function (obj) {
           return await objectToFormData(obj);
       }
   }
});